import { render, staticRenderFns } from "./FooterColumnMobileTheme1.vue?vue&type=template&id=16133a3b&scoped=true"
import script from "./FooterColumnMobileTheme1.vue?vue&type=script&lang=js"
export * from "./FooterColumnMobileTheme1.vue?vue&type=script&lang=js"
import style0 from "./FooterColumnMobileTheme1.vue?vue&type=style&index=0&id=16133a3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16133a3b",
  null
  
)

export default component.exports